import styled from 'styled-components';
import tw from 'twin.macro';

export default styled.div(({ $padding }) => [
  tw`relative block bg-white border border-solid border-silver-lighten-20 rounded`,
  $padding === 4 && tw`p-4`,
  $padding === 16 && tw`p-16`,
  $padding === 24 && tw`p-24`
]);
